import { Controller } from '@hotwired/stimulus';

import ajax from '@/modules/ajax';

const BURST_COLORS = ['#f43f5e', '#fb923c', '#facc15', '#4ade80', '#60a5fa', '#c084fc'];
const BURST_COUNT = 14;
const BURST_DURATION = 700;
const COOLDOWN = BURST_DURATION + 100;

export default class extends Controller {
  static targets = ['icon'];
  static values = { active: Boolean, type: String, url: String };

  burst() {
    const canvas = document.createElement('canvas');
    const size = 120;

    canvas.classList.add('heart-burst');

    this.element.classList.add('heart-burst-wrapper');
    this.element.appendChild(canvas);

    const context = canvas.getContext('2d');

    canvas.width = size;
    canvas.height = size;

    const particles = Array.from({ length: BURST_COUNT }, (_, i) => {
      const angle = (i / BURST_COUNT) * Math.PI * 2;

      return {
        alpha: 1,
        color: BURST_COLORS[i % BURST_COLORS.length],
        radius: Math.random() * 3 + 2,
        speed: Math.random() * 2 + 1.5,
        vx: Math.cos(angle),
        vy: Math.sin(angle),
        x: size / 2,
        y: size / 2,
      };
    });

    const start = performance.now();

    const frame = (now) => {
      const elapsed = now - start;
      const progress = elapsed / BURST_DURATION;

      context.clearRect(0, 0, size, size);

      particles.forEach((item) => {
        item.x += item.vx * item.speed;
        item.y += item.vy * item.speed;
        item.alpha = Math.max(0, 1 - progress);

        context.globalAlpha = item.alpha;
        context.fillStyle = item.color;
        context.beginPath();
        context.arc(item.x, item.y, item.radius, 0, Math.PI * 2);
        context.fill();
      });

      if (elapsed < BURST_DURATION) {
        requestAnimationFrame(frame);
      } else {
        canvas.remove();

        this.element.classList.remove('heart-burst-wrapper');
      }
    };

    requestAnimationFrame(frame);
  }

  click() {
    if (this.pending) return;

    this.pending = true;

    ajax({
      always: () => setTimeout(() => (this.pending = false), COOLDOWN),
      body: { value: 1, voteable_type: this.typeValue },
      done: () => {
        this.activeValue = !this.activeValue;

        if (this.activeValue) this.burst();
      },
      method: 'PATCH',
      url: this.urlValue,
    });
  }

  activeValueChanged() {
    this.iconTarget.classList.toggle('heart--on', this.activeValue);
    this.iconTarget.classList.toggle('heart--off', !this.activeValue);
  }
}
